import React from 'react';
import { Table } from 'react-bootstrap';
import { BsFillSquareFill } from 'react-icons/bs';


function GeraTabela({ data, acertaHora, corIcon }) {
    return (
        <>
            <Table striped hover className="Table mr-5 ml-5">
                <thead className="Header-table">
                    <tr>
                        <th>{" "}</th>
                        <th>TEMPO</th>
                        <th>RA</th>
                        <th>NOME</th>
                        <th>EXAME</th>
                        <th>STATUS</th>
                        <th>ENTREGA</th>
                    </tr>
                </thead>
                <tbody className="Body-table">
                    {data.map((item, index) => (
                        <tr key={`item_${index}`}>
                            <td><BsFillSquareFill className={corIcon(item.tempo_decorrido, item.tempo)}/></td>
                            <td>{acertaHora(item.tempo_decorrido)}</td>
                            <td>{item.ra}</td>
                            <td>{item.nm_paciente}</td>
                            <td>{item.exame}</td>
                            <td>{item.status}</td>
                            <td>{item.nm_entrega}</td>
                        </tr>
                    ))}

                </tbody>
            </Table>
        </>
    );
}

export default GeraTabela;